import React, { useState } from 'react';
import { useMutation } from 'react-query';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiTextField from '@material-ui/core/TextField';

import * as API from 'api';

const ReportInvoices = API.ReportInvoices();

const EditNoteDialog = ({ handleDialogClose, editingNotesId, notes, refetchReportInvoices }) => {
  const [formValues, setFormValues] = useState({});
  const handleFormSubmit = evt => {
    evt.preventDefault();
    patchReportInvoiceNotesMutation.mutate(formValues);
  };

  const patchReportInvoiceNotesMutation = useMutation(
    ({ notes }) => ReportInvoices.patchNotes(editingNotesId, { notes }),
    {
      onSuccess: async () => {
        await refetchReportInvoices();
        handleDialogClose();
      },
      onError: error => {
        alert(error);
        patchReportInvoiceNotesMutation.reset();
      },
    }
  );

  return (
    <MuiDialog open={editingNotesId >= 0} fullWidth maxWidth="md" onClose={handleDialogClose}>
      <MuiDialogTitle>Edit Report Invoice Notes</MuiDialogTitle>
      <form onSubmit={handleFormSubmit}>
        <MuiDialogContent>
          <MuiTextField
            type="text"
            name="notes"
            multiline
            minRows={3}
            defaultValue={notes}
            placeholder={'enter notes'}
            onChange={({ target: { name, value } }) => setFormValues({ [name]: value })}
          />
        </MuiDialogContent>
        <MuiDialogActions>
          <MuiButton variant="contained" onClick={handleDialogClose}>
            Cancel
          </MuiButton>
          <MuiButton variant="contained" color="primary" type="submit">
            Save
          </MuiButton>
        </MuiDialogActions>
      </form>
    </MuiDialog>
  );
};

export default EditNoteDialog;
